import React from 'react';
import Button from '../Button/Button';
import './NewsRoomList.css';
import { Link as RouterLink } from 'react-router-dom';

const Link = ({ to, children, ...rest }) => {
  const handleClick = () => {
    window.scrollTo(0, 0); // Scroll to top when a link is clicked
  };

  return (
    <RouterLink to={to} onClick={handleClick} {...rest}>
      {children}
    </RouterLink>
  );
};

const NewsRoomList = ({ data }) => {
  return (
    <div className='NewsRoomList-Container'>
      <div className='NewsRoomList-AllCards'>
        {data.map((newsItem) => (
          <Link
            key={newsItem._id} // Use _id directly as it's a string
            to={`/news/${newsItem._id}`} // Use _id for redirection
            className='NewsRoomList-CardLink'
          >
            <div className='NewsRoomList-Card'>
              <div className='NewsRoomList-CardLeft'>
                <img
                  src={newsItem.photo} // Correct field name for the image
                  alt={newsItem.title}
                  className='NewsRoomList-image'
                />
              </div>
              <div className='NewsRoomList-CardRight'>
                <p className='NewsRoomList-Date'>{newsItem.date}</p>
                <h1 className='NewsRoomList-Title'>{newsItem.title}</h1>
                <p className='NewsRoomList-Description'>{newsItem.details}</p> {/* Adjusted to match 'details' field */}
                <div className='NewsRoomList-ButtonContainer'>
                  <Button to={`/news/${newsItem._id}`}>{newsItem.button}</Button> {/* Button redirection */}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default NewsRoomList;
